import { createContext, useContext, useMemo, useCallback } from 'react';
import { THEME_MODE_STORAGE_KEY } from 'theme';

const ThemeModeContext = createContext();

const getStoredMode = () => {
  const stored = localStorage.getItem(THEME_MODE_STORAGE_KEY);
  return stored === 'dark' ? 'dark' : 'light';
};

export const ThemeModeProvider = ({ children }) => {
  const mode = getStoredMode();

  const setMode = useCallback((nextMode) => {
    const normalized = nextMode === 'dark' ? 'dark' : 'light';
    if (normalized === getStoredMode()) return;
    localStorage.setItem(THEME_MODE_STORAGE_KEY, normalized);
    window.location.reload();
  }, []);

  const value = useMemo(() => ({ mode, setMode }), [mode, setMode]);

  return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
};

export const useThemeMode = () => useContext(ThemeModeContext);
